import { useApolloClient } from "@apollo/client"
import { merge } from "lodash-es"

import {
  NeoletterUserProfileDocument,
  NeoletterUserProfileQuery,
  NeoletterUserProfileQueryVariables
} from "shared/api/neoletter-user-profile/queries.generated"
import { NeoletterUserProfile } from "shared/types/__generated__/graphql"

export function useNeoletterUserProfileCache() {
  const { cache } = useApolloClient()

  const handleUpdateCustomFieldsCache = (
    newCustomFields: Partial<NeoletterUserProfile["custom_fields"]>
  ) => {
    cache.updateQuery<
      NeoletterUserProfileQuery,
      NeoletterUserProfileQueryVariables
    >(
      {
        query: NeoletterUserProfileDocument
      },
      data => {
        if (!data || !data.neoletterUserProfile?.id) {
          return null
        }
        return {
          ...data,
          neoletterUserProfile: {
            ...data.neoletterUserProfile,
            custom_fields: merge(
              {},
              data?.neoletterUserProfile?.custom_fields,
              newCustomFields
            )
          }
        }
      }
    )
  }

  return {
    updateCustomFieldsCache: handleUpdateCustomFieldsCache
  }
}
